import { render, staticRenderFns } from "./quote-details-view.vue?vue&type=template&id=f310b2ca&scoped=true&"
import script from "./quote-details-view.vue?vue&type=script&lang=js&"
export * from "./quote-details-view.vue?vue&type=script&lang=js&"
import style0 from "./quote-details-view.vue?vue&type=style&index=0&id=f310b2ca&scoped=true&lang=css&"
import style1 from "./quote-details-view.vue?vue&type=style&index=1&id=f310b2ca&lang=scss&scoped=true&"
import style2 from "./quote-details-view.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f310b2ca",
  null
  
)

export default component.exports